
import type { PropType } from 'vue'
import type { IndexJobTransformationState } from '../../models'
import { computed, defineComponent } from 'vue'
import { EpbBadge } from '../shared/epb-badge'

export default defineComponent({
  name: 'IndexJobStateBadge',
  components: {
    EpbBadge,
  },
  props: {
    state: {
      type: String as PropType<IndexJobTransformationState | 'PARTIAL_SUCCESS'>,
      required: true,
    },
    tooltip: {
      type: String,
      default: undefined,
    },
  },
  setup(props) {
    const baseClass = 'epb-index-job-state-badge'

    const icon = computed<string>(() => {
      let result: string
      switch (props.state) {
        case 'QUEUED':
          result = 'queue'
          break
        case 'RUNNING':
          result = 'loader'
          break
        case 'SUCCESS':
          result = 'success'
          break
        case 'PARTIAL_SUCCESS':
          result = 'partialsuccess'
          break
        case 'FAILURE':
          result = 'alert'
          break
        case 'DISCARDED':
          result = 'discarded'
          break
      }
      return result
    })

    return {
      baseClass,
      icon,
    }
  },
})
